import { defineMessages } from "react-intl";

const messages = defineMessages({
  pendingMessage: {
    id: "Unknown.RecordLockedState.pendingMessage",
    defaultMessage:
      "This record is temporarily locked as it is involved in a merge",
  },
});

export default messages;
